import React, { Component } from "react";
import { Modal } from "antd";
import { callApi } from "../../utils/api";
import { FaRegFilePdf } from "react-icons/fa6";
import { saveAs } from "file-saver";
import { PiFileDocDuotone } from "react-icons/pi";
import { FaEye, FaChevronDown, FaChevronRight } from "react-icons/fa";
import moment from "moment";
import {
  ToastsStore,
} from "react-toasts";

interface ReportModalProps {
  visible: boolean;
  onClose: () => void;
  fileData: {
    id?: string;
    file_no?: string;
    lh_branch?: string;
    bank_name?: string;
    borrower_name?: string;
    property_owner?: string;
    loginBy?: string;
  } | null;
  match: any;
}

interface ReportModalState {
  updateDownloadData: {
    reasonForDownload: any[];
    updatedDetails: any[];
  };
  isReasonForDownloadShown: boolean;
  isUpdateDownloadShown: boolean;
  blockDownload: string;
  pageDynamic: any[];
  LHBranchCode: string;
  pdfToPreview: string;
  selectedFiles: {
    pdf: boolean;
    word: boolean;
  };
  hasCheckedItem: boolean;
  isUploadModalVisible: boolean;
  reportSendPayload: any;
  uploading: boolean;
  // New state for auto mail trigger
  isAutoMailLogExpanded: boolean;
  autoMailLogData: any[];
  loadingAutoMailLog: boolean;
}

class ReportModal extends Component<ReportModalProps, ReportModalState> {
  constructor(props: ReportModalProps) {
    super(props);

    this.state = {
      updateDownloadData: {
        reasonForDownload: [],
        updatedDetails: [],
      },
      isReasonForDownloadShown: false,
      isUpdateDownloadShown: false,
      blockDownload: "",
      pageDynamic: [],
      LHBranchCode: "",
      pdfToPreview: "",
      selectedFiles: {
        pdf: false,
        word: false
      },
      hasCheckedItem: false,
      isUploadModalVisible: false,
      reportSendPayload: null,
      uploading: false,
      // Initialize new state
      isAutoMailLogExpanded: false,
      autoMailLogData: [],
      loadingAutoMailLog: false
    };
  }

  componentDidUpdate(prevProps: ReportModalProps) {
    if (prevProps.visible !== this.props.visible && this.props.visible) {
      console.log("Modal page coming", this.props.fileData?.id);
      this.getBranchCode();
      this.getPageDynamicData();
      this.getUpdateReasonData();
    }
  }

  getBranchCode = () => {
    callApi("POST", "vetting_get_branch_code.php", {
      id: this.props.fileData?.id,
    })
      .then((res) => res.data)
      .then((response) => {
        const branchCode = response.data[0].lawhands_branch;
        this.setState({ LHBranchCode: branchCode });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getUpdateReasonData = () => {
    const reasonData: any = this.state.updateDownloadData;
    callApi("POST", "vetting_dashboard_log.php", {
      id: this.props.fileData?.id,
      path: "dashboard",
    })
      .then((res) => res.data)
      .then((result) => {
        reasonData.reasonForDownload = result.data.reasonForDownload;
        reasonData.updatedDetails = result.data.updatedDetails;
        this.setState({ updateDownloadData: reasonData });
      })
      .catch((err) => {
        // ToastsStore.error("Failed to get ");
      });
  };

  // New method to fetch auto mail trigger log
  getAutoMailTriggerLog = () => {
    if (!this.props.fileData?.id) return;
    
    this.setState({ loadingAutoMailLog: true });
    
    callApi("POST", "vetting_auto_mail_trigger_log.php", {
      id: this.props.fileData?.id
    })
      .then((res) => res.data)
      .then((response) => {
        if (response.result && response.data && response.data.logList) {
          this.setState({ autoMailLogData: response.data.logList });
        } else {
          this.setState({ autoMailLogData: [] });
        }
      })
      .catch((err) => {
        console.error("Error fetching auto mail trigger log:", err);
        ToastsStore.error("Failed to load auto mail trigger log");
        this.setState({ autoMailLogData: [] });
      })
      .finally(() => {
        this.setState({ loadingAutoMailLog: false });
      });
  };

  // Toggle auto mail log section
  toggleAutoMailLog = () => {
    const willExpand = !this.state.isAutoMailLogExpanded;
    
    this.setState({ isAutoMailLogExpanded: willExpand });
    
    // Fetch data when expanding
    if (willExpand && this.state.autoMailLogData.length === 0) {
      this.getAutoMailTriggerLog();
    }
  };

  getPageDynamicData = () => {
    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    let obj = {
      roleId: userDetails ? userDetails.role_id : null,
      userId: userDetails ? userDetails.userId : null,
      roleType: userDetails ? userDetails.roleType : null,
    };
    callApi("POST", "authenticating_pages_list_new.php", obj)
      .then((res) => res.data)
      .then((result) => {
        this.setState({ pageDynamic: result.responseJson.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleFileSelect = (type: 'pdf' | 'word') => {
    this.setState(prevState => {
      const newSelectedFiles = {
        ...prevState.selectedFiles,
        [type]: !prevState.selectedFiles[type]
      };

      const hasCheckedItem = newSelectedFiles.pdf || newSelectedFiles.word;

      return {
        selectedFiles: newSelectedFiles,
        hasCheckedItem
      };
    });
  };

showUploadConfirmation = () => {
  if (!this.state.hasCheckedItem) return;

  const user: any = localStorage.getItem("user");
  const userId = user ? JSON.parse(user)["userId"] : "";
  
  // Fix: Handle both selections properly
  let selectedFileTypes = "";
  if (this.state.selectedFiles.pdf && this.state.selectedFiles.word) {
    selectedFileTypes = "PDF & Word Vetting Manual Trigger";
  } else if (this.state.selectedFiles.pdf) {
    selectedFileTypes = "PDF Vetting Manual Trigger";
  } else if (this.state.selectedFiles.word) {
    selectedFileTypes = "Word Vetting Manual Trigger";
  }

  // Prepare payload for confirmation
  const payload = {
    file_id: this.props.fileData?.id,
    send_pdf: this.state.selectedFiles.pdf,
    send_word: this.state.selectedFiles.word,
    "file_status": selectedFileTypes,
    "created_by": userId
  };

  this.setState({
    isUploadModalVisible: true,
    reportSendPayload: payload
  });
};

  hideUploadConfirmation = () => {
    this.setState({
      isUploadModalVisible: false,
      reportSendPayload: null
    });
  };

  sendUploadPayload = async () => {
    this.setState({ uploading: true });

    return callApi(
      "POST",
      "vetting_auto_mail_report_send.php",
      this.state.reportSendPayload
    )
      .then(res => res.data)
      .then(response => {
        if (response.result === true) {
          ToastsStore.success(response.data.message);

          this.setState({
            selectedFiles: {
              pdf: false,
              word: false,
            },
            hasCheckedItem: false
          });

          this.hideUploadConfirmation();
        } else {
          ToastsStore.error(response.data.message);
        }
      })
      .catch(err => {
        console.error(err);
        ToastsStore.error("Upload failed");
      })
      .finally(() => {
        this.setState({ uploading: false });
      });
  };


  renderDetailsCard = (type, listOfData) => {
    return (
      listOfData &&
      listOfData.map((listVal, listIndex) => {
        return (
          <div
            className="row"
            key={`${listIndex}-${listVal.title}`}
            style={{
              background:
                listIndex === 0 && type === "UPDATE" ? "#cdffe0" : "#eff3f6",
              boxShadow: "0 0 0 1px #e2e5e8",
              borderRadius: "0.25rem",
              padding: "10px",
              paddingLeft: "12px",
              paddingRight: "12px",
              marginBottom: "15px",
            }}
          >
            <div style={{ width: "100%" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <p
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "black",
                    textTransform: "capitalize",
                  }}
                >
                  {listVal.title || ""}
                </p>
                {type === "UPDATE" ? (
                  <div style={{ display: "flex", gap: "20px" }}>
                    {this.state.pageDynamic.map((page: any, index: any) => {
                      if (
                        page.page_name === "PDF Download" &&
                        page.status == true
                      ) {
                        return (
                          <FaRegFilePdf
                            key={`pdf-download-${index}`}
                            onClick={() =>
                              this.documentDownload(listVal, "pdf")
                            }
                            style={{
                              fontSize: "21px",
                              color: "black",
                              cursor: "pointer",
                            }}
                          />
                        );
                      } else if (
                        page.page_name === "DOC Download" &&
                        page.status == true &&
                        listVal.file_upload_sign == 0
                      ) {
                        return (
                          <PiFileDocDuotone
                            key={`doc-download-${index}`}
                            onClick={() =>
                              this.documentDownload(listVal, "docx")
                            }
                            style={{
                              fontSize: "24px",
                              color: "black",
                              cursor: "pointer",
                            }}
                          />
                        );
                      } else if (
                        page.page_name === "PDF Preview" &&
                        page.status == true
                      ) {
                        return (
                          <FaEye
                            key={`preview-${index}`}
                            data-toggle="modal"
                            data-target="#preview-pdf"
                            style={{
                              fontSize: "20px",
                              color: "black",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              this.previewPDF(
                                Array.isArray(listVal.url) && listVal.url[0].pdf
                              )
                            }
                          />
                        );
                      }
                      return null;
                    })}
                  </div>
                ) : null}
              </div>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex" }}>
                  <p style={{ margin: "0px", color: "grey", fontSize: "13px" }}>
                    {moment(listVal.date).format("DD-MM-YYYY hh:mm a")} <br />
                  </p>
                  {listVal.officerType && (
                    <p
                      style={{
                        margin: "0px",
                        color: "black",
                        fontSize: "13px",
                        fontWeight: "bold",
                        marginLeft: "10px",
                        marginRight: "10px",
                        textTransform: "capitalize",
                      }}
                    >
                      {listVal.officerType}
                    </p>
                  )}
                  {listVal.downloadedBy && (
                    <p
                      style={{ margin: "0px", fontSize: "13px", color: "grey" }}
                    >
                      {type === "DOWNLOAD" ? "Downloaded By " : "Updated By "}{" "}
                      <span style={{ color: "black", fontWeight: "bold" }}>
                        {listVal.downloadedBy || ""}
                      </span>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })
    );
  };

  // New method to render auto mail trigger log entries
  renderAutoMailLogEntries = () => {
    const { autoMailLogData, loadingAutoMailLog } = this.state;

    if (loadingAutoMailLog) {
      return (
        <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
          Loading...
        </div>
      );
    }

    if (!autoMailLogData || autoMailLogData.length === 0) {
      return (
        <div style={{ 
          textAlign: 'center', 
          padding: '20px', 
          backgroundColor: '#f9f9f9',
          borderRadius: '4px',
          color: '#666'
        }}>
          No data available.
        </div>
      );
    }

    return autoMailLogData.map((log, index) => (
      <div
        key={`log-${index}`}
        style={{
          backgroundColor: index === 0 ? "#cdffe0" : "#eff3f6",
          boxShadow: "0 0 0 1px #e2e5e8",
          borderRadius: "0.25rem",
          padding: "10px",
          marginBottom: "10px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p style={{ fontWeight: "bold", fontSize: "14px", color: "black" }}>
            {log.title || "Auto Mail Trigger"}
          </p>
        </div>
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
          <p style={{ margin: "0px", color: "grey", fontSize: "13px" }}>
            {moment(log.date).format("DD-MM-YYYY hh:mm a")}
          </p>
          {log.officerType && (
            <p style={{ 
              margin: "0px", 
              color: "black", 
              fontSize: "13px", 
              fontWeight: "bold", 
              marginLeft: "10px", 
              marginRight: "10px",
              textTransform: "capitalize"
            }}>
              {log.officerType}
            </p>
          )}
          {log.downloadedBy && (
            <p style={{ margin: "0px", fontSize: "13px", color: "grey" }}>
              Updated By <span style={{ color: "black", fontWeight: "bold" }}>
                {log.downloadedBy}
              </span>
            </p>
          )}
          {log.report_type && (
            <p style={{ 
              marginLeft: "auto", 
              fontSize: "12px", 
              color: "#666",
              backgroundColor: "#e0e0e0",
              padding: "2px 8px",
              borderRadius: "12px"
            }}>
              {log.report_type}
            </p>
          )}
        </div>
      </div>
    ));
  };

  documentDownload = (listVal, type) => {
    if (type == "docx") {
      const name = `${this.state.LHBranchCode}-${this.props.fileData?.id}.docx`;
      Array.isArray(listVal.url) &&
        listVal.url[0].docx &&
        saveAs(listVal.url[0].docx, name);
    } else {
      const name = `${this.state.LHBranchCode}-${this.props.fileData?.id}.pdf`;
      Array.isArray(listVal.url) &&
        listVal.url[0].pdf &&
        saveAs(listVal.url[0].pdf, name);
    }
  };

  previewPDF = (url) => {
    this.setState({ pdfToPreview: url });
  };

  render() {
    const { visible, onClose, fileData } = this.props;
    const {
      updateDownloadData,
      selectedFiles,
      hasCheckedItem,
      isUploadModalVisible,
      pageDynamic,
      isAutoMailLogExpanded,
      autoMailLogData
    } = this.state;

    const autoMail = this.state.pageDynamic && this.state.pageDynamic.find((page: any) => page.page_name === "Vetting Report Shared Manually" && page.status == true);
    
    return (
      <>
        <Modal
          title="File Report"
          centered
          visible={visible}
          onCancel={onClose}
          footer={null}
          className="modal-report"
          width={700}
        >
          <div>
            {autoMail &&
              <div className="row">
                <div className="col-sm-12 text-md-center">
                  <div className="d-flex justify-content-center align-items-center mb-2" style={{ gap: "15px" }}>
                    <h6>Report Shared Manually</h6>
                    <button
                      onClick={this.showUploadConfirmation}
                      disabled={!hasCheckedItem}
                      style={{
                        padding: '5px 15px',
                        backgroundColor: !hasCheckedItem ? '#cccccc' : '#1890ff',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: !hasCheckedItem ? 'not-allowed' : 'pointer',
                        opacity: !hasCheckedItem ? 0.5 : 1,
                        fontSize: '14px',
                        transition: 'all 0.3s ease',
                      }}
                    >
                      Send Report
                    </button>
                  </div>
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(3, auto)',
                      gap: '30px',
                      justifyContent: 'center',
                      marginTop: '20px',
                      marginBottom: '20px',
                      textAlign: 'center'
                    }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {pageDynamic.map((page: any, index: any) => {
                      if (
                        page.page_name === "Vetting Manual Mail Send PDF" &&
                        page.status == true
                      ) {
                        return (
                          <div
                            key={`pdf-${index}`}
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              cursor: 'pointer',
                              opacity: selectedFiles.pdf ? 1 : 0.5
                            }}
                            onClick={() => this.handleFileSelect('pdf')}
                          >
                            <div style={{ position: 'relative' }}>
                              <FaRegFilePdf style={{ fontSize: "22px" }} />
                              {selectedFiles.pdf && (
                                <div style={{
                                  position: 'absolute',
                                  top: '-5px',
                                  right: '-5px',
                                  backgroundColor: '#1890ff',
                                  borderRadius: '50%',
                                  width: '15px',
                                  height: '15px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  <span style={{ color: 'white', fontSize: '10px' }}>✓</span>
                                </div>
                              )}
                            </div>
                            <span style={{ fontSize: '10px', marginTop: '6px' }}>Send <br /> PDF</span>
                          </div>
                        );
                      } else if (
                        page.page_name === "Vetting Manual Mail Send Word" &&
                        page.status == true
                      ) {
                        return (
                          <div
                            key={`word-${index}`}
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              cursor: 'pointer',
                              opacity: selectedFiles.word ? 1 : 0.5
                            }}
                            onClick={() => this.handleFileSelect('word')}
                          >
                            <div style={{ position: 'relative' }}>
                              <PiFileDocDuotone style={{ fontSize: "26px" }} />
                              {selectedFiles.word && (
                                <div style={{
                                  position: 'absolute',
                                  top: '-5px',
                                  right: '-5px',
                                  backgroundColor: '#1890ff',
                                  borderRadius: '50%',
                                  width: '15px',
                                  height: '15px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  <span style={{ color: 'white', fontSize: '10px' }}>✓</span>
                                </div>
                              )}
                            </div>
                            <span style={{ fontSize: '10px', marginTop: '6px' }}>Send Word</span>
                          </div>
                        );
                      }
                      return null;
                    })}
                  </div>
                </div>
              </div>
            }

            {/* New Auto Mail Trigger Log Section */}
            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
              <div 
                onClick={this.toggleAutoMailLog}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  padding: '10px',
                  backgroundColor: '#f0f0f0',
                  borderRadius: '4px',
                  marginBottom: '10px'
                }}
              >
                {isAutoMailLogExpanded ? <FaChevronDown /> : <FaChevronRight />}
                <h6 style={{ margin: '0 0 0 10px', fontWeight: 'bold' }}>
                  Auto Mail Trigger Log
                </h6>
              </div>
              
              {isAutoMailLogExpanded && (
                <div style={{ padding: '10px 0' }}>
                  {this.renderAutoMailLogEntries()}
                </div>
              )}
            </div>

            {updateDownloadData && updateDownloadData.updatedDetails ? (
              <div className="div">
                {this.renderDetailsCard(
                  "UPDATE",
                  updateDownloadData.updatedDetails
                )}
              </div>
            ) : (
              <p>No data available.</p>
            )}
          </div>
        </Modal>

        {/* Ant Design Modal for Confirmation */}
        <Modal
          title="Confirm Upload"
          visible={isUploadModalVisible}
          onOk={this.sendUploadPayload}
          onCancel={this.hideUploadConfirmation}
          okText="Yes, Upload"
          cancelText="Cancel"
          okButtonProps={{
            loading: this.state.uploading,
            disabled: this.state.uploading,
            type: 'primary',
            style: { backgroundColor: '#1890ff' }
          }}
        >
          <div style={{ padding: '10px 0' }}>
            <p>Are you sure you want to upload with the following selections?</p>

            <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                <span>File Type</span>
                <span>Status</span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid #e8e8e8' }}>
                <span>Send PDF</span>
                <span style={{
                  color: selectedFiles.pdf ? '#52c41a' : '#ff4d4f',
                }}>
                  {selectedFiles.pdf ? '✓ Selected' : '✗ Not Selected'}
                </span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid #e8e8e8' }}>
                <span>Send Word</span>
                <span style={{
                  color: selectedFiles.word ? '#52c41a' : '#ff4d4f',
                }}>
                  {selectedFiles.word ? '✓ Selected' : '✗ Not Selected'}
                </span>
              </div>
            </div>
          </div>
        </Modal>

        <div
          className="modal fade"
          id="preview-pdf"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ maxWidth: "1400px" }}
          >
            <div className="modal-content" style={{ height: "90vh" }}>
              <div className="modal-header">
                <h5 className="modal-title">Document Preview</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <iframe
                  width="100%"
                  height="100%"
                  src={`${this.state.pdfToPreview}#toolbar=0`}
                ></iframe>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.setState({ pdfToPreview: "" });
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default ReportModal;